import { render } from "./ShowBonDist.vue?vue&type=template&id=7e334f1a&ts=true"
import script from "./ShowBonDist.vue?vue&type=script&lang=ts"
export * from "./ShowBonDist.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__